import ReactDOM from 'react-dom';

import ModalView from '@/components/modal/ModalView';
import useModalStore from '@/stores/modalStore';

const OutOfChatModalPortal = () => {
  const { modalsOutOfChat } = useModalStore();
  const container = document.getElementById('out-of-chat-modal') as HTMLElement;

  return ReactDOM.createPortal(
    <div>
      {modalsOutOfChat.map((modal) => (
        <ModalView {...modal} key={modal.type} />
      ))}
    </div>,
    container,
  );
};

export default OutOfChatModalPortal;
